import React from 'react';
import { useStyles } from '@archipro-design/aria';
import * as S from './PaintPalette.style';
import { CloseLine } from '@archipro-design/icons';
import { motion } from 'framer-motion';
import { PaintColour } from '@modules/paint-picker/component/paint-colours/PaintColour';
import { RESENE_PROFESSIONAL_LINK } from '@modules/paint-picker/config';
import { usePaintPickerContext } from '@modules/paint-picker/context/PaintPickerContext';
import { useTracker } from '@archipro-website/tracker';

interface PaintPaletteProps {
    onClose: () => void;
    icon: JSX.Element;
    logo?: JSX.Element;
}

export const PaintPalette = ({ onClose, icon, logo }: PaintPaletteProps) => {
    const { css } = useStyles();
    const tracker = useTracker();
    const {
        state: { previewPaint },
        paintSelection,
        addPaintToSelection,
    } = usePaintPickerContext();

    const colourSelection = paintSelection.map((colour) => {
        return <PaintColour key={'colour' + colour.id} {...colour} />;
    });

    return (
        <div className={css(S.Container)}>
            <motion.div variants={S.headAnimation} className={css(S.Top)}>
                {icon}
                <a
                    target="_blank"
                    href={RESENE_PROFESSIONAL_LINK}
                    rel="noopener"
                    onClick={() => {
                        tracker.log(
                            'Resene-PhotoViewer-PaintList-ReseneLogo-Click',
                            {
                                url: new URL(window.location.href),
                            }
                        );
                    }}
                >
                    {logo}
                </a>
                <CloseLine className={css(S.CloseButton)} onClick={onClose} />
            </motion.div>

            {previewPaint && (
                <>
                    <p className={css(S.PreviewTitle)}>Resene Preview</p>
                    <p className={css(S.PreviewSubTitle)}>
                        Click image or preview to add colour
                    </p>
                    <motion.ul
                        variants={S.bodyAnimation}
                        className={css(S.ColoursList)}
                    >
                        <PaintColour
                            {...previewPaint}
                            onClick={() => addPaintToSelection(previewPaint)}
                            isPreview={true}
                        />
                    </motion.ul>
                </>
            )}

            {colourSelection.length > 0 && (
                <>
                    <p className={css(S.PaletteTitle)}>Your Colour Palette</p>
                    <motion.ul
                        variants={S.bodyAnimation}
                        className={css(S.ColoursList)}
                    >
                        {colourSelection}
                    </motion.ul>
                </>
            )}
        </div>
    );
};
